/**
 * Builds display name for a master variant: "{Parent title} - {Option value 1} / {Option value 2}".
 * Option values follow product.availableOptions order.
 */
export function buildMasterVariantDisplayName({
  productTitle = '',
  availableOptions = [],
  variantOptions = {},
}) {
  const optionValues = availableOptions
    .map(({ name }) => variantOptions[name])
    .filter((value) => value != null && value !== '');

  if (!optionValues.length) return productTitle || '';

  return `${productTitle} - ${[...optionValues].join(' / ')}`;
}
